import React from 'react';
// Note: ReactDOM is not typically needed directly in component files unless using findDOMNode
// import ReactDOM from 'react-dom'; 
// createReactClass is replaced by standard class syntax
// import createReactClass from 'create-react-class'; 
import 'datetimepicker'; // Ensure jQuery and the plugin are loaded globally or imported correctly

// Convert to ES6 class syntax
class Calendar extends React.Component {
	// Optional: displayName can be set as a static property
	// static displayName = "Calendar";

	// Replace getInitialState with a constructor
	constructor(props) {
		super(props);
		this.state = {
			// title: I('Chose'),
			value: "",
			humanValue: "", // Initialize based on props later in componentDidMount
			// timepicker: false, // Determined by props, not really state
			// format: 'Y/m/d', // Determined by props/logic, not really state
			// closeOnDateSelect: true, // Configuration, not state
			valid: true,
			// datepicker: false // Determined by props, not really state
		};
		// Bind methods if not using arrow functions (arrow functions recommended)
		// this.handleDateTimeChange = this.handleDateTimeChange.bind(this);
		// this.handleOnChange = this.handleOnChange.bind(this);
		// this.handleOnDelete = this.handleOnDelete.bind(this);
	}

	// Replace getDefaultProps with static defaultProps
	static defaultProps = {
		allowPastDate: true,
		disabled: false,
		type: "input", // Default type if not provided
		timepicker: false,
		selectedDate: "",
		selectedTimestamp: "",
		onChange: () => {}, // Default no-op function for onChange
		onDelete: () => {} // Default no-op function for onDelete
	};

	// Use componentDidMount for initialization and side effects
	componentDidMount() {
		let initialHumanValue = "";
		const today = new Date();
		const todayHuman = this.toHumanDate(today);

		if (this.props.selectedDate) {
			initialHumanValue = this.props.selectedDate;
		} else if (this.props.selectedTimestamp) {
			initialHumanValue = this.toHumanDateFromTimestamp(this.props.selectedTimestamp);
		} else {
			initialHumanValue = todayHuman;
			// Avoid calling props.onChange during mount if initial value is derived,
			// unless specifically required by the parent component logic.
			// Check if this immediate onChange call is necessary.
			// If not, remove it. If yes, ensure it doesn't cause loops.
			// this.props.onChange(todayHuman); // Potential issue here
		}

		// Extract date part if needed (e.g., "YYYY/MM/DD HH:MM" -> "YYYY/MM/DD")
		// This logic seems specific to date-only pickers, adjust if time is included
		const elem = initialHumanValue.split(' ');
		const displayValue = this.props.timepicker ? initialHumanValue : elem[0]; // Use full value if timepicker

		this.setState({ humanValue: displayValue }, () => {
			 // Initialize datetimepicker *after* state is set
			this.createDateTimePicker(this.state.humanValue);
			this.checkDisabled();
		});
		
		// Remove the setTimeout, initialization should be synchronous after state update
		// setTimeout(() => {
		//     this.createDateTimePicker(this.state.humanValue);
		//     this.checkDisabled();
		// }, 1000);
	}

	// Replace componentWillReceiveProps with componentDidUpdate
	componentDidUpdate(prevProps, prevState) {
		// 1. Check if disabled prop changed
		if (prevProps.disabled !== this.props.disabled) {
			this.checkDisabled(); // Re-apply disabled state to picker if needed
		}

		// 2. Check if selectedDate prop changed *and* differs from current state
		// Avoid unnecessary updates if internal state already matches prop
		if (this.props.selectedDate && this.props.selectedDate !== prevProps.selectedDate && this.props.selectedDate !== this.state.humanValue) {
			
			// Extract date part if necessary, consistent with componentDidMount
			const valueParts = this.props.selectedDate.split(' ');
			const displayValue = this.props.timepicker ? this.props.selectedDate : valueParts[0];

			this.setState({ humanValue: displayValue }, () => {
				// Update the datetimepicker instance instead of destroy/recreate if possible
				const dtpInstance = $('#' + this.props.id).datetimepicker;
				if (dtpInstance && typeof dtpInstance === 'function') {
					// Attempt to update the value. Check plugin docs for the correct method.
					// Common methods: 'setOptions', 'setDate', 'setValue'
					 try {
					   $('#' + this.props.id).datetimepicker('setOptions', { value: this.state.humanValue });
					 } catch (e) {
						console.error("Failed to update datetimepicker value, fallback to recreate:", e);
						// Fallback if setOptions fails or isn't supported for value changes
						this.destroyDateTimePicker();
						this.createDateTimePicker(this.state.humanValue);
					 }
				} else {
					 // Fallback if instance not found
					 this.destroyDateTimePicker();
					 this.createDateTimePicker(this.state.humanValue);
				}
			});
		}
		// Avoid comparing state in componentDidUpdate if the update was triggered by setState within this method
		// Only compare props or specific state transitions if needed
	}

	componentWillUnmount() {
		this.destroyDateTimePicker();
	}
	
	// Utility to safely destroy the picker
	destroyDateTimePicker = () => {
		 const dtpInstance = $('#' + this.props.id).datetimepicker;
		 if (dtpInstance && typeof dtpInstance === 'function') {
			 try {
				$('#' + this.props.id).datetimepicker('destroy');
			 } catch(e) {
				 console.error("Error destroying datetimepicker:", e);
			 }
		 }
	}

	// Refactored checkDisabled to potentially enable/disable the plugin instance
	checkDisabled = () => {
		const dtpInstance = $('#' + this.props.id).datetimepicker;
		if (dtpInstance && typeof dtpInstance === 'function') {
			 // Check plugin documentation for how to enable/disable
			 // It might be via setOptions or specific methods
			 // Example: $('#' + this.props.id).datetimepicker('setOptions', { disabled: this.props.disabled });
			 // Or it might control the input element directly:
			 $('#' + this.props.id).prop('disabled', this.props.disabled); 
			 // The original code re-initialized, which might be necessary if disabling isn't directly supported
			 // Re-initializing might be less efficient but safer if unsure.
			 
			 // Original logic (re-initializes, potentially less efficient but maybe required by plugin):
			 /*
			 var conf = {};
			 conf.datepicker = !this.props.timepicker;
			 conf.timepicker = this.props.timepicker;
			 // Apply other configurations based on props if necessary
			 $('#' + this.props.id).datetimepicker(conf); 
			 */
			 // For now, let's just disable the input as it's simpler and often sufficient
			 $('#' + this.props.id).prop('disabled', this.props.disabled);
		}
	}

	// Convert methods to arrow functions for automatic `this` binding
	createDateTimePicker = (value) => {
		const id = '#' + this.props.id;
		const isTimepicker = this.props.timepicker;
		let format = "Y/m/d"; // Default date format
		if (isTimepicker) {
			format = (this.props.timeFormat === ":") ? "H:i" : "Hi"; // Time format
		}

		const defaultConf = {
			value: value || null, // Use null if value is empty for placeholder
			closeOnDateSelect: !isTimepicker, // Close only if datepicker
			lang: (typeof currentInterface !== 'undefined' && currentInterface !== "" ? currentInterface : 'en'), // Assuming currentInterface is global
			dayOfWeekStart: 1, // Swedish weekday start from Monday
			onChangeDateTime: this.handleDateTimeChange,
			step: 5,
			format: format,
			datepicker: !isTimepicker,
			timepicker: isTimepicker,
			disabled: this.props.disabled // Pass disabled state initially
			// Add minDate based on allowPastDate prop
			// minDate: this.props.allowPastDate ? false : 0 // 0 sets minDate to today
		};

		 // Add minDate logic more carefully
		if (!this.props.allowPastDate) {
			defaultConf.minDate = 0; // 0 typically means today in datetimepicker
		}


		// Ensure previous instance is destroyed before creating a new one if necessary
		// Although we try to update, recreation might be needed on format change etc.
		this.destroyDateTimePicker(); 
		$(id).datetimepicker(defaultConf);
	}

	handleDateTimeChange = (dp, $input) => {
		const hmdate = $input.val();
		let valid = true;

		if (!this.props.allowPastDate && !this.props.timepicker) { // Past date check only for datepicker
			const today = this.toHumanDate(new Date());
			if (hmdate && hmdate < today) {
				valid = false;
				// Optionally provide feedback or reset?
				// For now, just don't update state if invalid
			}
		}

		if (valid) {
			// Update internal state first
			this.setState({
				value: this.props.timepicker ? hmdate : this.toTimeStamp(new Date(hmdate + ' 00:00:00')), // Store raw value or timestamp
				humanValue: hmdate,
				valid: true // Assuming valid if logic passes
			}, () => {
				 // Call props.onChange *after* state update
				 this.props.onChange(hmdate, this.props.id);
			});

			// Original timestamp logic (seems overly complex, simplifying above)
			/*
			if(this.props.timepicker){
				this.setState({ value: hmdate, humanValue: hmdate });
				this.props.onChange(hmdate, this.props.id);
			} else {
				// This timestamp conversion with timezone offset seems suspicious. 
				// Standard Date object handles local time correctly.
				// Storing the simple human date or a standard timestamp is usually sufficient.
				let adjustedDateStr = hmdate + ' 00:00:00';
				let timestamp = (new Date(adjustedDateStr)).getTime() / 1000;
				
				// Re-evaluate if timezone manipulation is truly needed.
				// var timezoneDate = new Date();
				// var timezoneOffset = timezoneDate.getTimezoneOffset() * 60;
				// var now = new Date();
				// now.setTime((timestamp - timezoneOffset) * 1000);

				let dateObj = new Date(adjustedDateStr); // Use direct date obj
				this.setState({
					value: this.toTimeStamp(dateObj), 
					humanValue: this.toHumanDate(dateObj) 
				});
				this.props.onChange(this.toHumanDate(dateObj));
			}
			*/
		} else {
			 // Handle invalid date (e.g., past date not allowed)
			 this.setState({ valid: false });
			 // Maybe revert input value or show error? Currently just flags state.
		}
	}

	// Keep utility functions as methods or move outside class if pure
	toHumanDateFromTimestamp = (timestamp) => {
		var date = new Date(timestamp * 1000);
		return this.toHumanDate(date);
	}

	toHumanDate = (dt) => {
		// Ensure dt is a valid Date object
		if (!(dt instanceof Date) || isNaN(dt)) {
			return ""; // Return empty string for invalid dates
		}
		var dd = dt.getDate();
		var mm = dt.getMonth() + 1;
		var yyyy = dt.getFullYear();
		if (dd < 10) { dd = '0' + dd }
		if (mm < 10) { mm = '0' + mm }
		return yyyy + '/' + mm + '/' + dd;
	}

	toTimeStamp = (dt) => {
		 // Ensure dt is a valid Date object
		if (!(dt instanceof Date) || isNaN(dt)) {
			return null; // Return null for invalid dates
		}
		var newDt = dt.getTime() / 1000;
		return (newDt | 0); // Bitwise OR for integer conversion
	}

	// This handler seems for direct input changes, which might conflict with picker changes
	// Evaluate if this is still needed or if handleDateTimeChange covers all updates
	handleOnChange = (e) => {
		const inputval = e.target.value;
		// Manually setting state here might fight with the picker's onChangeDateTime
		// It's usually better to let the picker's callback handle the state update.
		// Consider removing this or reconciling its logic with handleDateTimeChange.

		this.setState({ humanValue: inputval });

		// Updating the picker's value directly might be okay, but let's test without it first
		// $('#' + this.props.id).datetimepicker({ value: inputval });

		// The timestamp conversion logic here is also questionable and likely redundant
		// if handleDateTimeChange is working correctly.
		/*
		var hmdate = $('#'+this.props.id).datetimepicker('getValue').val(); // This might not exist or work reliably
		if (!hmdate) hmdate = inputval; // Fallback? Risky.
		
		hmdate = hmdate + ' 00:00:00';
		var tmdate = (new Date(hmdate)).getTime() / 1000;

		var timezoneDate = new Date();
		var timezoneOffset = timezoneDate.getTimezoneOffset() * 60; 

		var now = new Date();
		now.setTime((tmdate - timezoneOffset) * 1000);

		this.setState({
			value: this.toTimeStamp(now),
			humanValue: inputval // Keep user input visually?
		});

		this.props.onChange(this.toHumanDate(now)); // Report potentially different date?
		*/
	   // Let's simplify: assume handleDateTimeChange is the source of truth for updates
	   // If manual input is desired, it needs careful integration.
	}

	handleOnDelete = (e) => {
		e.preventDefault(); // Prevent default link behavior if called from <a>
		this.setState({ humanValue: "", value: "", valid: true }); // Clear state
		$('#' + this.props.id).datetimepicker('setOptions', { value: null }); // Clear picker value
		this.props.onDelete(); // Notify parent
	}

	// Helper render function for delete button
	renderDeleteDueDate = () => {
		// Only show delete if value exists and type allows delete
		if (this.state.humanValue && this.state.humanValue !== "None" && this.props.type === "link") {
			return (
				// Use button for better accessibility
				<button 
				   type="button" 
				   className="remove-duedate" 
				   onClick={this.handleOnDelete} 
				   aria-label="Remove date" // Accessibility
				   style={{ marginLeft: '5px', border: 'none', background: 'none', cursor: 'pointer' }} 
				 >
					<i className="glyphicon glyphicon-remove"></i> 
				 </button>
			);
		}
		return null;
	}

	render() {
		// Render based on type prop
		if (this.props.type === "link" || this.props.type === "linkNoDel") {
			// Use the component's ID for the anchor if needed, but maybe span is better?
			// The anchor was likely used to trigger the datetimepicker initialization originally.
			// Let's keep it similar for now but ensure picker targets the correct element.
			return (
				<span>
					{/* The anchor itself doesn't need the ID if the input handles the picker */}
					{/* Using a button or span might be semantically better */}
					<a href="#" id={this.props.id} onClick={(e) => e.preventDefault()}> 
						{this.state.humanValue || I("None")}
					</a>
					{this.props.type === "link" && this.renderDeleteDueDate()}
				</span>
			);
		}

		// Default render as input group
		return (
			// The outer span doesn't need the ID if the input has it.
			// className might need adjustment based on styling needs.
			<span className="input-group input-group-sm" style={{ display: 'inline-block', pointerEvents: this.props.disabled ? 'none' : 'auto', opacity: this.props.disabled ? 0.7 : 1 }}>
				<input
					name={this.props.id} // Name might be useful for forms
					id={this.props.id} // ID for the picker to attach to
					style={{ float: 'left', width: 80 }} // Adjust styling as needed
					className="form-control"
					placeholder={this.props.timepicker ? "HH:MM" : "YYYY/MM/DD"} // Placeholder hint
					// Use state value for controlled input. Direct DOM manipulation by jQuery can fight this.
					value={this.state.humanValue} 
					// Let handleDateTimeChange update state. Manual onChange might interfere.
					onChange={this.handleOnChange} // Keep for now, but review if needed
					disabled={this.props.disabled}
					readOnly={this.props.type === 'link' || this.props.type === 'linkNoDel'} // Prevent input if using link style
				/>
				{/* This addon might not be necessary if the input itself triggers the picker */}
				<span className="input-group-addon" id={"addon-" + this.props.id}><i className="fa fa-calendar"></i></span>
			</span>
		);
	}
}

// Export the class component
export default Calendar;